import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import AlertComp from '../Shared/AlertComp';
import { ComprimirImagen } from '../../Assets/JS/ComprimirImagen.js';

export const ImportImage = React.memo(({ urlImage, alt, setImage, image, classWidth = 'classWidth_ine' }) => {
    const imgFormat = { name: '', size: 0, type: '' };
    const oInitialState = Array.isArray(image) ? imgFormat : image;
    const [state, setState] = useState(oInitialState);
    const SIZE_FILE_MAX = 5;
    const oAlert = {
        bool: false,
        data: { label: '' }
    };
    const [dataAlert, setdataAlert] = useState(oAlert);
    const randomID = () => {
        return Math.floor(Math.random() * 999999);
    };
    const [idComponent, setIdComponent] = useState(randomID());

    useEffect(() => {
        setIdComponent(randomID())
    }, []);

    const inputFileChange = async (e) => {
        // const _file = e.target.files[0]

        const _file = e.target.files[0]

        if (_file) {
            cleanFile();
            const reader = new FileReader();
            const validExtention = validateFileType(_file.name);

            let size = 0
            if (_file.type == "application/pdf") {
                size = _file.size / 1048576;  //Para tenerlos en Megas   
            } else {
               // var archivo = await ComprimirImagen(_file, 95);
                size = _file.size / 1048576;  //Para tenerlos en Megas   
                // console.log(`size Original MB ${_file.size / 1048576}`);
                // console.log(`size MB ${size}`);
            }


            if (size > SIZE_FILE_MAX) {
                setdataAlert({ bool: true, label: "¡Archivo inválido!, Intente subir otro archivo menor a 5 MB", variant: "warning" })
                setTimeout(() => {
                    setdataAlert({ bool: false, label: "", variant: "" })
                }, 5000);
            } else if (validExtention) {

                //const fileLoad = _file.type == "application/pdf" ? _file : archivo;
                const fileLoad = _file;
              
                reader.readAsDataURL(fileLoad);
                reader.onload = () => {

                    setState(fileLoad);
                    if (fileLoad.type !== 'application/pdf') {
                        const _url = reader.result;
                       
                        setImage(image => (
                            {
                                ...image,
                                file: fileLoad,
                                url: _url
                            })
                        );
                        
                    } else {
                        setImage(image => (
                            {
                                ...image,
                                file: fileLoad,
                            })
                        );
                    }
                };
            } else {
                setdataAlert({ bool: true, label: "¡Archivo inválido!, Intente subir otro archivo .png .pdf ó .jpg", variant: "warning" })
                setTimeout(() => {
                    setdataAlert({ bool: false, label: "", variant: "" })
                }, 5000);

            }
        }
    };
    const cleanFile = () => {
        setState(imgFormat);
        setImage(image => (
            {
                ...image,
                file: [],
                url: image.urlBase
            })
        );
        document.getElementById(`id${idComponent}`).value = '';
    };
    const validateFileType = (fileName) => {
        let Extensions = ['.pdf', '.png', '.jpg', '.jpeg'];
        var regex = new RegExp("([a-zA-Z0-9s_\\.()-:])+(" + Extensions.join('|') + ")$");
        if (!regex.test(fileName.toLowerCase())) {
            return false;
        } else {
            return true;
        }
    };

    return (
        <div className="card-body card-img-sh card-from-img mt-4" >
            <div>
                <label htmlFor={"id" + idComponent}>
                    <img className={classWidth} src={urlImage} alt={alt} />
                </label>

                <>
                    <input type="file" accept="image/*, application/pdf" id={"id" + idComponent} className="file" onChange={inputFileChange} />
                    {
                        state.name !== '' && (
                            <p className="image-name"> {state?.name}
                                <span>
                                    <button type="button" className="link-button" onClick={cleanFile}>
                                        <i className="fas fa-times icon-img" ></i>
                                    </button>
                                </span>
                            </p>
                        )
                    }
                    <AlertComp bool={dataAlert.bool} label={dataAlert.label} variant={dataAlert.variant} />
                </>
                <div className='font-weight-bold mt-3 form_text_img'>
                    Archivo .JPG, .PNG o .PDF (Tamaño máx 5MB)
                </div>
            </div>
        </div>
    )
})
ImportImage.propTypes = {
    urlImage: PropTypes.string.isRequired,
    setImage: PropTypes.func.isRequired
}
ImportImage.defaultProps = {
    alt: 'Default Image'
}